var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('random-img',{staticClass:"bg-primary position-absolute p-0 h-100",attrs:{"prefix":'guest/mobile/header-',"max":4}})}
var staticRenderFns = []

export { render, staticRenderFns }